@let isEditUser = isEditUser$ | async;
<div class="container-fluid px-8 py-4 py-md-8">
    <div class="row">
        <div class="col-12 order-2 order-lg-1" [class.col-lg-7]="isEditUser">
            <div class="p-4 bg-gray-light mt-6 mt-lg-0 rounded">
                <h4 class="mb-3">{{ 'global.labels.filter' | translate }}</h4>
                <b2b-invoice-filter
                    [statuses]="statuses$ | async"
                    [pending]="pending$ | async"
                    [prgId]="prgId"
                    (submitForm)="applyFilterInvoices($event)" />
            </div>
        </div>
        @if (isEditUser) {
            <div class="col-12 col-lg-5 order-1 order-lg-2">
                <div class="p-4 border-radius-4 bg-light min-h-100 rounded">
                    <h4 class="mb-3">{{ 'global.actions.createInvoice' | translate }}</h4>
                    <b2b-invoice-form [pending]="pendingCreateInvoice$ | async" [prgId]="prgId" (createInvoice)="createInvoice($event)" />
                </div>
            </div>
        }
    </div>
</div>

<div class="container-fluid overflow-hidden px-0 pb-md-8">
    <div class="row">
        <div class="col-12">
            <b2b-table-b2b-invoices
                [readonly]="!isEditUser"
                [dateFormat]="dateFormat"
                [pending]="pending$ | async"
                [invoices]="invoices$ | async"
                [handlers]="handlersGrid"
                (changeInvoiceStatus)="openChangeStatusDialog($event)" />
        </div>
    </div>
</div>
